<div class="ml-auto w-full text-right justify-end -mt-4 -mr-3">
    <button id="closeModalChangeStatus2" mat-icon-button (click)="closeModal()" tabindex="-1">
        <mat-icon class="close-x-primary">close</mat-icon>
    </button>
</div>

<div class="pb-3 text-center title-text-modal">
    {{ 'companySettingDialog' | translate }}
</div>

<div *ngIf="company" class="flex flex-col gap-4 mt-4 company-config pb-2">
    <div class="w-full" *ngIf="!company.comP_IS_MINI">
        <div class="flex items-center gap-1">
            <span class="title-input-text">{{"clientDetailConfCountDays" | translate}}</span>
            <mat-icon
                [matTooltip]="(company.comP_USE_NATURAL_DAYS ? 'clientDetailConfCountDaysTooltip2' : 'clientDetailConfCountDaysTooltip') | translate"
                class="help-icon">help</mat-icon>
        </div>
        <mat-select id="clientDetailConfCountDays" [(ngModel)]="company.comP_USE_NATURAL_DAYS" name="natural" id=""
            class="bordee brown-border pt-1" (selectionChange)="onSelectDays($event)" (focus)="onFocus($event)"
            (blur)="onBlur($event)" [disabled]="sending">
            <mat-option [value]="true">{{ "naturales" | translate }}</mat-option>
            <mat-option [value]="false">{{ "laborales" | translate }}</mat-option>
        </mat-select>
    </div>

    <div *ngIf="!company.comP_USE_NATURAL_DAYS && !company.comP_IS_MINI" class="w-full">
        <div class="flex items-center gap-1">
            <span class="title-input-text">{{"clientDetailConfWorkedDays" | translate}}</span>
            <mat-icon [matTooltip]="'clientDetailConfWorkedDaysTooltip' | translate" class="help-icon">help</mat-icon>
        </div>
        <mat-select id="clientDetailConfWorkedDays" [(ngModel)]="company.comP_WORKING_DAYS_PER_WEEK" name="worked" id=""
            class="bordee brown-border pt-1" (focus)="onFocus($event)" (blur)="onBlur($event)" [disabled]="sending">
            <mat-option [value]="7">{{ "sevenDays" | translate }}</mat-option>
            <mat-option [value]="6">{{ "sixDays" | translate }}</mat-option>
            <mat-option [value]="5">{{ "fiveDays" | translate }}</mat-option>
        </mat-select>
    </div>

    <div *ngIf="company.comP_IS_AGENCY" class="w-full">
        <div class="flex items-center gap-1">
            <span class="title-input-text">{{"cvConfigDialog" | translate}}</span>
            <mat-icon [matTooltip]="'cvConfigDialogTooltip' | translate" class="help-icon">help</mat-icon>
        </div>
        <mat-slide-toggle id="clientDetailUserListRole" name="role" [(ngModel)]="cvPreference" color="primary" (change)="onCvPreferenceChange($event)"
            class="text-center w-full pt-1" [disabled]="sending">
            <div class="pr-3 gray-text font-medium text-sm">
                {{"CVClientPreference" | translate}}
            </div>
        </mat-slide-toggle>
    </div>

    <div class="w-full flex justify-center pt-2">
        <app-custom-primary-button id="candidateCopyQrDialog" (click)="saveCompany()" size="mini" color="primary"
            class="text-center w-full md:w-auto" [disabled]="sending">
            <span *ngIf="!sending">{{ "saveButton" | translate }}</span>
            <div *ngIf="sending" class="w-full flex justify-center">
                <mat-spinner diameter="20" color="primary"></mat-spinner>
            </div>
        </app-custom-primary-button>
    </div>
</div>